'use strict';

import * as angular from 'angular';
import { JSONConfigurationComponent } from './components/json-config/json-config.component';
var app = angular.module('noc.shared', []);

app.directive('authorization', require('./directives/authorizationDirective'));
app.directive('autoCompleteQuery', require('./directives/autoCompleteQueryDirective'));
app.directive('collapseFilterMenu', require('./directives/collapseFilterMenu'));
app.directive('collapseWidth', require('./directives/collapseWidth'));
app.directive('datepickerPopup', require('./directives/datepickerPopup'));
app.directive('datepickerPopupWrap', require('./directives/datepickerPopupWrap'));
app.directive('fileReader', require('./directives/fileReader'));
app.directive('fullheightContent', require('./directives/fullheightContent'));
app.directive('ngEnter', require('./directives/ngEnter'));
app.directive('selectTab', require('./directives/selectTab'));
app.directive('showErrors', require('./directives/showErrors'));
app.provider('showErrorsConfig', require('./directives/showErrorsConfig'));
app.directive('watchChange', require('./directives/watchChange'));

app.filter('pagination', require('./filters/pagination'));
app.filter('strLimit', require('./filters/strLimit'));
app.filter('tzdate', require('./filters/timezoneDate'));
app.filter('tzdate_extensive', require('./filters/timezoneDateExtensive'));
app.filter('displayCustomTrainTypeName', require('./filters/displayCustomTrainTypeName'));

app.factory('GoogleMapsFactory', require('./google-maps/googleMapsFactory'));
app.directive('googleMapsLegend', require('./google-maps/googleMapsLegend'));
app.directive('googleMapsTrainSearch', require('./google-maps/googleMapsTrainSearch'));
app.directive('mapReferenceareaOverlay', require('./google-maps/mapReferenceareaOverlay'));

// app.directive('bootstrapSwitch', require('./bootstrapSwitch'));
app.factory('ChartFactory', require('./chartFactory'));
app.factory('CsvFactory', require('./csvFactory'));
app.factory('HighChartFactory', require('./highChartFactory'));
app.factory('MessageDataFactory', require('./messageDataFactory'));
app.factory('MessageDataQueryFactory', require('./messageDataQueryFactory'));
app.factory('NotificationFactory', require('./notificationFactory'));
app.directive('presetDateTimePicker', require('./presetDateTimePickerDirective'));
app.filter('roundNumber', require('./roundNumberFilter'));
app.directive('screenLogger', require('./screenLoggerDirective'));
app.factory('ScreenLoggerFactory', require('./screenLoggerFactory'));
app.factory('SqiFactory', require('./sqiFactory'));
app.directive('toggleButton', require('./toggleButton'));
app.directive('unfocusClick', require('./unfocusButtonDirective'));

app.service('modalService', require('./services/modalService/modalService'));

app.directive('rightClick', require('./directives/rightClickDirective'));

app.component('jsonConfig', JSONConfigurationComponent);
app.directive('jsonDiffDir', require('./directives/jsonDiff'));

export default app;